import { Vector2 } from 'three'
import { useSceneStore } from '../../../../a.scenes/GameScene/store'

const calculatePath = (origin: Vector2, destination: Vector2) =>
  new Promise<Vector2[]>(res => {
    const terrainApi = useSceneStore.getState().terrain

    terrainApi.calcPath(origin.x, origin.y, destination.x, destination.y, path => res(path || []))
  })
const getShortestPath = (pathsCandidates: Vector2[][]) =>
  pathsCandidates
    .filter(p => p.length > 0)
    .reduce((result: Vector2[] | null, currentPath: Vector2[]) => {
      if (!result || currentPath.length < result.length) {
        return currentPath
      }
      return result
    }, null)
export const getShortestPathToDestinations = async (coordsO: Vector2, destinations: Vector2[]) => {
  const isInTarget = destinations.find((dest: Vector2) => dest.equals(coordsO))
  if (isInTarget === undefined) {
    // calc paths from current position to each tile in the destination array
    const pathsCandidates = await Promise.all(destinations.map(tileCoords => calculatePath(coordsO!, tileCoords)))

    // get cheaper move path (the shortest)
    const cheaperMovePath = getShortestPath(pathsCandidates)

    return cheaperMovePath
  } else {
    return []
  }
}
